var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0730C522-BF34-448D-8906-50C702220B4C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Car-insurance---3---RTO-&-City---2",
    transform: "translate(-972.000000, -403.000000)",
    fill: "#202020",
    fillRule: "nonzero",
    stroke: "#202020"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(100.000000, 122.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(343.000000, 267.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M535.229028,19.9989925 L539.952786,15.2752338 C540.015738,15.2122621 540.015738,15.1101852 539.952786,15.0472136 C539.889815,14.9842621 539.787738,14.9842621 539.724766,15.0472136 L535.001007,19.7709724 L530.277249,15.0472136 C530.213189,14.9853506 530.111112,14.9871245 530.049229,15.0511846 C529.988877,15.1136724 529.988877,15.2127459 530.049229,15.2752338 L534.772987,19.9989925 L530.049229,24.7227513 C529.985168,24.7846344 529.983395,24.8867113 530.045278,24.9507715 C530.107161,25.0148316 530.209238,25.0166054 530.273298,24.9547223 C530.274648,24.9534322 530.275959,24.9521019 530.277249,24.9507715 L535.001007,20.2270127 L539.724766,24.9507715 C539.788826,25.0126546 539.890903,25.0108807 539.952786,24.9468206 C540.013158,24.8843328 540.013158,24.7852391 539.952786,24.7227513 L535.229028,19.9989925 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/close-btn.e947915c8a2c0905bff3c4f76046cf7e.svg";
export { ForwardRef as ReactComponent };